import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

type UpdateSellingTypesPayload = {
  selling_types: {
    dine_in_view: 0 | 1;
    dine_in: 0 | 1;
    car_pickup: 0 | 1;
    car_pickup_without_details: 0 | 1;
    delivery: 0 | 1;
  };
  wizard?: string;
}

type UpdateMenuTypesPayload = {
  mobile_orders: 0 | 1; // enable cart in webapp if dine_in_view is enabled
  level: 0 | 1; // enable cart in tablet if dine_in_view is enabled
  qr_menu: 0 |1;
  tablet_menu: 0 | 1;
  wizard?: string;
}

type UpdateDineInPayload = {
  floors: Array<{
    id?: number;
    name: string;
    tables: Array<{
      id?: number;
      name: string;
      sort: number;
      persons: number;
    }>;
  }>;
  wizard?: string;
}

type UpdateDeliveryPayload = {
  form: {
    type: 'residency' | 'address';
    fields: Record<string, {
      on: 0 | 1;
      required: 0 | 1;
    }>;
  };
  wizard?: string;
}

type UpdatePaymentMethodsPayload = {
  payment_methods: {
    cash: {
      dine_in: 0 | 1 | boolean;
      delivery: 0 | 1 | boolean;
      car_pickup: 0 | 1 | boolean;
    };
    credit: {
      dine_in: 0 | 1 | boolean;
      delivery: 0 | 1 | boolean;
      car_pickup: 0 | 1 | boolean;
    };
    pay_later: {
      dine_in: 0 | 1 | boolean;
      car_pickup: 0 | 1 | boolean;
      /// no pay later for delivery
    };
  };
  wizard?: string;
}

class SellingTypesAPIs {
  static async getSellingTypes(branchId: number) {
    return (await $http.get(`/ordering/selling-types/${branchId}`)).data
  }

  static async updateSellingTypes(branchId: number, payload: any) {
    const body = FormsService.convertBooleanToBinary(payload)
    return (await $http.put(`/ordering/selling-types/${branchId}`, body)).data
  }

  static async updateMenuTypes(branchId: number, payload: UpdateMenuTypesPayload) {
    const body = FormsService.convertBooleanToBinary(payload)
    return (await $http.put(`ordering/menu-types/${branchId}`, body)).data
  }

  static async updateDineInSettings(branchId: number, payload: UpdateDineInPayload) {
    const body = FormsService.convertBooleanToBinary(payload)
    return (await $http.put(`/ordering/dine-in-setting/${branchId}`, body)).data
  }

  static async updateDeliverySettings(branchId: number, payload: UpdateDeliveryPayload) {
    const body = FormsService.convertBooleanToBinary(payload)
    return (await $http.put(`/ordering/delivery-setting/${branchId}`, body)).data
  }

  static async updatePaymentMethods(branchId: number, payload: UpdatePaymentMethodsPayload) {
    const body = FormsService.convertBooleanToBinary(payload)
    return (await $http.put(`/ordering/payment-methods/${branchId}`, body)).data
  }
}

export default SellingTypesAPIs
